import React from "react";

export default function GranteeExemptionNotice(props) {
  return(
    (props.disableGranteeNotice || !props.isGrantee)
      ? null
      : <div className="stat-cards__notice stat-cards__notice--red stat-cards__notice--mb" style={{ lineHeight: 1.5 }}>
        The selected entity is exempted from this policy and is not required to make a single contract pharmacy
        designation. Any designation you make will not impact your access to 340B pricing.
        <a href={props.policy_doc_url}>
          <span style={{ fontWeight: 500, textDecoration: "underline", margin: "0px 5px" }}>
            Download Policy document
          </span>
        </a>
        Please reach out to
        <span style={{ fontWeight: 500 }}> support@340besp.com </span>
        if you have any additional questions or if you do not have access to 340B pricing for your contract pharmacies.
      </div>
  );
};
